import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { JobService } from 'src/app/_services/job.service';

@Component({
    selector: 'app-job-edit',
    templateUrl: './job-edit.component.html',
    styleUrls: ['./job-edit.component.css'],
    standalone: false
})
export class JobEditComponent implements OnInit {

  loading = true;
  submitting = false;
  jobForm: UntypedFormGroup;
  types = ['Full Time', 'Part time', 'Internship', 'Consultant', 'Freelance', 'Volunteer'];
  jobId: any;

  constructor(private jobService: JobService, private toastService: ToastrService,
    private router: Router, private fb: UntypedFormBuilder, private activatedRoute: ActivatedRoute) {
      this.jobId = this.activatedRoute.snapshot.paramMap.get('id') ?? '0';
      this.jobForm = this.fb.group({
        'title': new UntypedFormControl('', Validators.required),
        'description': new UntypedFormControl('', Validators.required),
        'location': new UntypedFormControl('', Validators.required),
        'type': new UntypedFormControl('', Validators.required),
        'status': new UntypedFormControl(true, Validators.required),
      });
  }

  ngOnInit(): void {
    this.jobService.loadJob(this.jobId).subscribe(
      (job) => {
        this.jobForm.patchValue({
          title: job.title,
          description: job.description,
          type: job.type,
          location: job.location,
          status: job.status,
        });
        this.loading = false;
      },
      (error) => {
        this.toastService.error(error);
        this.router.navigateByUrl('/admin/jobs');
      }
    );
  }

  submit() {
    this.submitting = true;
    this.jobService.updateJob(this.jobId, this.jobForm.value).subscribe(
      (response: any) => {
        this.toastService.success(response.message);
        this.router.navigateByUrl('/admin/jobs');
      },
      (error) => {
        this.toastService.error(error);
        this.submitting = false;
      },
    );
  }
}